import Danielle from '../../assets/images/doctors/Danielle Miller.webp'
import Ellayah from '../../assets/images/doctors/Ellayah Persons.webp'
import Fredrica from '../../assets/images/doctors/Fredrica.webp'
import Ivan from '../../assets/images/doctors/Ivan Estrada.webp'
import Jessica from '../../assets/images/doctors/Jessica Gabriel.jpg'
import Reginald from '../../assets/images/doctors/Reginald Louis.jpg'
import Shanessa from '../../assets/images/doctors/Shanessa Crook.jpeg'
import Tiana from '../../assets/images/doctors/Tiana Britton.jpeg'
import Kendajah from '../../assets/images/doctors/Kendajah Bolden.jpg'
import Mareba from '../../assets/images/doctors/Mareba Lewis.jpg'
import Keshia from '../../assets/images/doctors/Retouched_Keshia.jpg'


const DoctorsData = [

    // {
    //     id : 1,
    //     name: "Danielle Miller",
    //     image: Danielle,
    //     email: "QPS@yjcandwellness.com",
    //     availableTime: [
    //         {
    //             day: "Monday",
    //             type: "In Person",
    //             time: "12-7",
    //             hours : ['12-1','1-2','2-3','3-4','4-5','5-6','6-7']
    //         },
    //         {
    //             day: "Tuesday",
    //             type: "In Person",
    //             time: "11-6",
    //             hours : ['11-12','12-1','1-2','2-3','3-4','4-5','5-6']
    //         },
    //         {
    //             day: "Wednesday",
    //             type: "Virtual",
    //             time: "11-6",
    //             hours : ['11-12','12-1','1-2','2-3','3-4','4-5','5-6']
    //         },
    //         {
    //             day: "Thursday",
    //             type: "Virtual",
    //             time: "10-5",
    //             hours : ['10-11','11-12','12-1','1-2','2-3','3-4','4-5']
    //         },
    //         {
    //             day: "Friday",
    //             type: "In Person",
    //             time: "9-4",
    //             hours : ['9-10','10-11','11-12','12-1','1-2','2-3','3-4']
    //         },
    //     ],
    //     description: "Hi there! I'm Dani. I understand that life can feel overwhelming, which is why I offer a supportive, collaborative space where you can feel safe and empowered to connect with your most authentic self. I work with adolescents and adults, specializing in relationship challenges, grief, life transitions, substance use, anxiety, and depression. My integrative, person-centered approach draws from CBT, DBT, and Attachment Theory, allowing us to build a strong therapeutic alliance and support you in developing a personalized toolkit of coping skills to create meaningful, lasting change. If you're ready to take the next step, I'd love to hear from you. You're not alone. Let's talk!",
    // },

    {
        id : 2,
        name: "Ellayah Persons",
        image: Ellayah,
        email: "QPS@yjcandwellness.com",
        availableTime: [
            {
                day: "Monday",
                type: "In Person or Virtual",
                time: "8-7",
                hours: ['8-9', '9-10', '10-11', '11-12', '12-1', '1-2', '2-3', '3-4', '4-5', '5-6', '6-7']
            },
            {
                day: "Tuesday",
                type: "In Person or Virtual",
                time: "9-6",
                hours : ['9-10','10-11','11-12','12-1','1-2','2-3','3-4','4-5','5-6']
            },
            
            {
                day: "Thursday",
                type: "In Person or Virtual",
                time: "9-6",
                hours : ['9-10','10-11','11-12','12-1','1-2','2-3','3-4','4-5','5-6']
            },
            {
                day: "Friday",
                type: "Virtual",
                time: "9-6",
                hours : ['9-10','10-11','11-12','12-1','1-2','2-3','3-4','4-5','5-6']
            },
        ],
    description: "Hi, I'm Ellayah Persons! I'm excited to support you on your journey toward becoming your best self. I believe everyone can benefit from a bit of guidance, and I aim to provide a compassionate, supportive space for you to explore your thoughts and emotions. I specialize in helping individuals 8 and older manage stress, navigate self-identity, cope with trauma, and address body image concerns. My goal is to empower you to create positive changes by fostering self-awareness and resilience. Whether you're transitioning into adulthood or navigating the complexities of adulting, I'm here to help you build the tools needed to handle life's challenges with clarity and strength. I look forward to working with you!",
},
  

    // {
    //     id : 3,
    //     name: "Fredrica Dennis",
    //     image: Fredrica,
    //     email: "QPS@yjcandwellness.com",
    //     availableTime: [
    //         {
    //             day: "Monday",
    //             type: "Virtual",
    //             time: "10-5",
    //             hours : ['10-11', '11-12', '12-1', '1-2', '2-3', '3-4', '4-5']
    //         },
    //         {
    //             day: "Tuesday",
    //             type: "In Person",
    //             time: "11-6",
    //             hours : ['11-12', '12-1', '1-2','2-3','3-4', '4-5', '5-6']
    //         },
    //         {
    //             day: "Wednesday",
    //             type: "In Person",
    //             time: "12-7",
    //             hours: ['12-1', '1-2', '2-3', '3-4', '4-5', '5-6', '6-7']
    //         },
    //         {
    //             day: "Thursday",
    //             type: "In Person",
    //             time: "10-6",
    //             hours : ['10-11', '11-12', '12-01', '1-2', '2-3', '3-4', '4-5', '5-6']
    //         },
    //         {
    //             day: "Friday",
    //             type: "Virtual",
    //             time: "10-3",
    //             hours : ['10-11', '11-12', '12-01', '1-2', '2-3']
    //         },
    //     ],
    //     description: "Drica holds a deep belief in the resilience and potential of each individual, recognizing that life’s challenges, transitions, and traumas can sometimes veer us off course from our authentic selves. Drica has had the privilege of supporting kids, adolescents, adults, and families across cultures to support healing, self-awareness, and empowerment. Drica has experience with Autism, ADHD, anxiety, and depression. She also supports stress management, life transitions and well-being. Drica uses a mix of play therapy, mindfulness, CBT and solution-focused therapy to create an environment for growth. She believes play, creativity and authenticity are critical in all phases of life. In her spare time, she loves writing, playing sports, and listening to music.",
    // },

   
 
    {
        id : 5,
        name: "Reginald Louis",
        image: Reginald,
        email: "QPS@yjcandwellness.com",
        availableTime: [
            {
                day: "Monday",
                type: "In Person",
                time: "9-2",
                hours : ['9-10', '10-11', '11-12','12-1','1-2']
            },
            {
                day: "Tuesday",
                type: "In Person",
                time: "10-5",
                hours : ['10-11', '11-12','12-1','1-2','2-3','3-4','4-5']
            },
            {
                day: "Tuesday",
                type: "Virtual",
                time: "8-10",
                hours : ['8-9', '9-10']
            },
            {
                day: "Wednesday",
                type: "Virtual",
                time: "8-10",
                hours : ['8-9', '9-10']
            },
            {
                day: "Thursday",
                type: "In Person",
                time: "10-5",
                hours : ['10-11', '11-12','12-1','1-2','2-3','3-4','4-5']
            },
            {
                day: "Thursday",
                type: "Virtual",
                time: "8-10",
                hours : ['8-9', '9-10']
            },
            {
                day: "Friday",
                type: "In Person",
                time: "9-2",
                hours : ['9-10', '10-11', '11-12','12-1','1-2']
            },
            {
                day: "Saturday",
                type: "Virtual",
                time: "8-6",
                hours : ['8-9', '9-10', '10-11','11-12','12-1', '1-2', '2-3','3-4','4-5','5-6'] 
            },
            {
                day: "Sunday",
                type: "Virtual",
                time: "8-6",
                hours : ['8-9', '9-10', '10-11','11-12','12-1', '1-2', '2-3','3-4','4-5','5-6']
            }
        ],
        description: "Reginald specializes in helping couples strengthen connection, rebuild trust, and deepen intimacy through honest communication and emotional understanding. He integrates Cognitive Behavioral Therapy (CBT), mindfulness, and Horticultural Therapy to create a calm, supportive space where growth feels possible. Rooted in a framework of connection, Reginald guides partners to recognize patterns that block closeness and to cultivate empathy, emotional safety, and shared purpose. In his individual work, he supports clients navigating anxiety, depression, and life transitions—helping them restore balance, resilience, and self-worth. He also facilitates a men's group focused on breaking cycles of childhood trauma and becoming intentional, emotionally present fathers. Grounded, compassionate, and culturally attuned, Reginald believes relationships can thrive when nurtured with honesty, empathy, and care.",
    },
    
    {
        id : 6,
        name: "Shanessa Crook",
        image: Shanessa,
        email: "QPS@yjcandwellness.com",
        availableTime: [
            {
                day: "Monday",
                type: "In Person",
                time: "1-7",
                hours: ['1-2', '2-3', '3-4', '5-6', '6-7']
            },
            {
                day: "Wednesday",
                type: "In Person",
                time: "1 PM - 7 PM",
                hours: ['1-2', '2-3', '3-4', '5-6', '6-7']
            },
            {
                day: "Thursday",
                type: "Virtual",
                time: "9-4",
                hours : ['9-10', '10-11','11-12','12-1', '1-2', '2-3','3-4']
            },
            {
                day: "Friday",
                type: "Virtual",
                time: "8-3",
                hours : ['8-9', '9-10', '10-11','11-12','12-1', '1-2', '2-3']
            },
        ],
        description: "Hi and welcome! I’m Shanessa, a Licensed Professional Counselor (LPC). Do you ever feel overwhelmed and have a hard time finding balance in your life? Are you noticing a breakdown in your relationships (family, friends, partners) but don’t know how to repair them? Do you simply need unbiased support and guidance in your life? Yes, I’m talking to you! We can work together to decrease your stressors, improve relationships with effective communication, and make healthier choices. My strengths include being genuine, consistent, building relationships, introducing effective coping skills/communication, and helping my clients work towards their goals. Give yourself grace and remember that progress is progress! I look forward to meeting and working with you!",
    },
    // {
    //     id : 7,
    //     name: "Jessica Gabriel",
    //     image: Jessica,
    //     email: "QPS@yjcandwellness.com",
    //     availableTime: [
    //         {
    //             day: "Monday",
    //             type: "In Person",
    //             time: "11-7",
    //             hours : ['11-12', '12-1', '1-2','2-3','3-4', '4-5', '5-6', '6-7']
    //         },
    //         {
    //             day: "Tuesday",
    //             type: "In Person",
    //             time: "9-6",
    //             hours : ['9-10', '10-11', '11-12','12-1','1-2', '2-3', '3-4', '4-5','5-6']
    //         },
    //         {
    //             day: "Wednesday",
    //             type: "Virtual",
    //             time: "8-3",
    //             hours : ['8-9', '9-10', '10-11','11-12','12-1', '1-2', '2-3']
    //         },
    //         {
    //             day: "Thursday",
    //             type: "In Person",
    //             time: "10-6",
    //             hours : ['10-11', '11-12', '12-01', '1-2', '2-3', '3-4', '4-5', '5-6']
    //         },
    //         {
    //             day: "Friday",
    //             type: "Virtual",
    //             time: "9-12",
    //             hours : ['9-10', '10-11', '11-12']
    //         },
    //     ],
    //     description: "Jessica Gabriel is a Licensed Professional Counselor (LPC) with extensive experience in acute mental health care for individuals and families. Her background in inpatient settings has given her a deep understanding of the challenges people face during periods of crisis and transition, as well as the resilience that can be cultivated with appropriate support. She works with children and adults experiencing anxiety, depression, trauma, relationship concerns, and major life transitions. Jessica also specializes in supporting clients and their families as they adjust after inpatient treatment, rebuild stability, and strengthen communication. Jessica’s therapeutic approach is warm, collaborative, and grounded in evidence-based practice. She integrates Cognitive Behavioral Therapy (CBT), DBT-informed skills, Person-Centered Therapy, Emotion-Focused Therapy (EFT), and Motivational Interviewing to tailor care to each client’s unique needs. Known for her steady presence and genuine empathy, Jessica helps clients gain clarity, build emotional resilience, and move toward healthier, more fulfilling lives.",
    // },
    {
        id : 8,
        name: "Tiana Britton",
        image: Tiana,
        email: "QPS@yjcandwellness.com",
        availableTime: [
            {
                day: "Monday",
                type: "Virtual",
                time: "11-7",
                hours : ['11-12','12-1','1-2','2-3','3-4','4-5','5-6','6-7']
            },
            {
                day: "Tuesday",
                type: "In Person",
                time: "11-6",
                hours : ['11-12','12-1','1-2','2-3','3-4','4-5','5-6']
            },
           
            {
                day: "Thursday",
                type: "In Person",
                time: "9-4",
                hours : ['9-10','10-11','11-12','12-1','1-2','2-3','3-4']
            },
            {
                day: "Friday",
                type: "Virtual",
                time: "9-6",
                hours : ['9-10','10-11','11-12','12-1','1-2','2-3','3-4','4-5','5-6']
            },
            {
                day: "Saturday",
                type: "Virtual",
                time: "10-1",
                hours : ['10-11','11-12','12-1']
            }
        ],
        description: "Tiana finds working with diverse individuals highly rewarding and focuses on issues like depression, anxiety, trauma, stress, self-worth, and self-image. She uses cognitive behavioral therapy (CBT), person-centered therapy, and emotion-focused therapy (EFT) to emphasize the crucial role of emotions in daily life and relationships. Tiana is committed to creating a safe, empathetic, and genuine space for clients, fostering a strong therapeutic alliance and promoting healing. She encourages clients to take an active role in their therapeutic journey, supporting them in processing, growing, and healing at their own pace.",
    },
    {
        id : 9,
        name: "Dr. Mareba Lewis (LPC)",
        image: Mareba,
        email: "QPS@yjcandwellness.com",
        availableTime: [
            {
                day: "Tuesday",
                type: "In Person or Virtual",
                time: "10-4",
                hours : ['10-11','11-12','12-1','1-2','2-3','3-4']
            },
            {
                day: "Wednesday",
                type: "In Person or Virtual",
                time: "11-4",
                hours : ['11-12','12-1','1-2','2-3','3-4']
            }
        ],
        description: "A former U.S. Army officer, Dr. Mareba Lewis has lived across multiple countries and learned a simple truth: people everywhere want to be happy. For the past 15 years, she's helped clients pursue that goal with a steady, practical approach that blends evidence-based care with genuine warmth. Dr. Lewis works with adults and leaders navigating anxiety, depression, trauma, life transitions, relationships, and performance stress. Her style is collaborative and strengths-based, drawing from CBT, DBT-informed skills, mindfulness, and trauma-informed practices to tailor care to each person's needs. Grounded in service and discipline from her military career—and deep cultural sensitivity from living abroad—Dr. Lewis creates a respectful, goal-oriented space where clients feel seen, supported, and empowered to make meaningful change. Her mission is to help you clarify what happiness looks like for you—and to walk with you as you build it, step by step.",
    },
    
    {
        id : 10,
        name: "Keshia Irving",
        image: Keshia,
        email: "QPS@yjcandwellness.com",
        availableTime: [
            {
                day: "Monday",
                type: "Virtual",
                time: "4:30-9:30",
                hours: ['4:30-5:30','5:30-6:30','6:30-7:30','7:30-8:30','8:30-9:30']
            },
            {
                day: "Tuesday",
                type: "Virtual",
                time: "4:30-9:30",
                hours: ['4:30-5:30','5:30-6:30','6:30-7:30','7:30-8:30','8:30-9:30']
            },
            {
                day: "Wednesday",
                type: "Virtual",
                time: "4:30-9:30",
                hours: ['4:30-5:30','5:30-6:30','6:30-7:30','7:30-8:30','8:30-9:30']
            },
            {
                day: "Thursday",
                type: "In Person or Virtual",
                time: "5-8",
                hours: ['5-6','6-7','7-8']
            },
            {
                day: "Friday",
                type: "In Person or Virtual",
                time: "5-8",
                hours: ['5-6','6-7','7-8']
            },
            {
                day: "Saturday",
                type: "In Person or Virtual",
                time: "9:30-7",
                hours: ['9:30-10:30','10:30-11:30','11:30-12:30','12:30-1:30','1:30-2:30','2:30-3:30','3:30-4:30','4:30-5:30','5:30-6:30','6:30-7']
            }
        ],
        description: "Hi, my name is Keshia. My mission is to equip individuals in my community with the tools they need to build emotional stability and lasting change. Together, we will reframe your narrative and rewrite your future. I support mental and emotional wellness by incorporating mindfulness practices and increasing self-awareness, and I provide a safe, warm, and non-judgmental space for individuals, families, and couples to share their unique stories and experiences. In our work, I strive to get to the root of each concern while encouraging ongoing growth, healing, and resilience, and I look forward to partnering with you on your journey.",
    }

   

]

export default DoctorsData;
